import { z } from "zod";

export const idSchema = z
  .string()
  .uuid()
  .describe("Unique identifier for the item in UUID format.");
